import styled from 'styled-components';

import { Text } from '@catalyze/ui';

export const ContactTitle = styled(Text)`
    font-weight: 700;
    font-size: ${({ theme }) => theme.fontSizes[4]};
    max-width: 11rem;
    overflow-wrap: anywhere;
`;
